import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'

export function SupportTicket(
    subject,
    type,
    priority,
    email,
    phoneNumber,
    description,
    ticketRef
    ) {

    const supportTicket = {
        subject,
        type,
        priority,
        email,
        phoneNumber,
        description,
        ticketRef
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SupportTicket, supportTicket,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}